import Header from "@components/Header/Header"
import TransactionTypeTag from "@components/TransactionTypeTag/TransactionTypeTag"
import { useNavigate } from "react-router"
import { Container, AmountContainer, AmountText, TransactionTypeContainer } from "./TransactionDetailHeader.styles"
import SkeletonLoader from "@components/SkeletonLoader/SkeletonLoader"
import { toCurrencyFormat } from "@lib/utils"
import { JIDRCurrency } from "@components/CurrencyIcon/CurrencyIcon"
import { useTranslation } from "react-i18next"
import { setHeaderColor } from "@lib/telegram"
import { SKY_BLUE } from "@styles/colors"
import { useEffect } from "react"

type Props = {
    isLoading: boolean
    amount?: number
    code?: number
    goBackTo?: string
}

const TransactionDetailHeader = ({ isLoading, amount, code, goBackTo }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    useEffect(() => {
        setHeaderColor(SKY_BLUE)
    }, [])
    return (
        <Container>
            <Header title={t('components.transactionDetailHeader.title')} showBackButton={true} onBackClick={() => navigate(goBackTo || '/home')} $transparent={true} />
            <AmountContainer>
                {
                    isLoading ? 
                        <SkeletonLoader width={"20%"} height={"32px"} /> 
                        : 
                        <>
                            <JIDRCurrency />
                            <AmountText>{amount ? toCurrencyFormat(amount) : 'N/A'}</AmountText>
                        </>
                }
            </AmountContainer>
            <TransactionTypeContainer>
                {
                    isLoading ?
                    <SkeletonLoader width={"20%"} height={"32px"} />
                        :
                    <TransactionTypeTag code={code} />
                }
            </TransactionTypeContainer>
        </Container>
    )
}

export default TransactionDetailHeader